
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/prototyping",
      function () {
        return require("private-next-pages/cases/prototyping/index.tsx");
      }
    ]);
  